import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-humidor-popover-loading',
  templateUrl: './humidor-popover-loading.component.html',
  styleUrls: ['./humidor-popover-loading.component.scss'],
})
export class HumidorPopoverLoadingComponent implements OnInit, OnDestroy {

  @Input() loaded:Observable<number>;
  @Input() popoverType:string='default';//anderer Text für Statistiken
  public progress:number=0;
  public progress_next:number=0;
  private updated=0;
  private loadSub:Subscription=null;
  constructor(private translate:TranslateService) {

  }

  ngOnInit() {
    this.loadSub=this.loaded.subscribe((loaded)=>{
      this.progress=loaded;
      this.updated++;
      this.progress_next=this.progress+(this.progress/this.updated);
    });
  }

  ngOnDestroy(): void {
    if(this.loadSub!==null){
      this.loadSub.unsubscribe();
    }
  }

}
